module.exports = __webpack_public_path__ + "static/img/360js_img_2.408b6550.png";